import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../../shared/lib/firebase';
import { resolveSupportSettings } from '../lib/support';
import type { SupportSettings } from '../lib/types';

const REF = () => doc(db, 'support_settings', 'config');

export function useSupportSettings() {
  const [settings, setSettings] = useState<SupportSettings>(() => resolveSupportSettings(undefined));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onSnapshot(REF(), (snap) => {
      setSettings(resolveSupportSettings(snap.data() as Partial<SupportSettings> | undefined));
      setLoading(false);
    }, (err) => { console.error('[useSupportSettings]', err); setLoading(false); });
    return unsub;
  }, []);

  return { settings, loading };
}
